import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnreRoutingModule } from './anre-routing.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {Ng2SmartTableModule} from 'ng2-smart-table';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CKEditorModule} from 'ngx-ckeditor';
import { PersonalDataAnreComponent } from './personal-data-anre/personal-data-anre.component';
import { TaskAnreComponent } from './task-anre/task-anre.component';
import { NotificationsAnreComponent } from './notifications-anre/notifications-anre.component';
import { SuppliersAnreComponent } from './suppliers-anre/suppliers-anre.component';
import { OperatorSupplierValidationComponent } from './task-anre/details/operator-supplier-validation/operator-supplier-validation.component';
import { SuppliersFuiComponent } from './suppliers-anre/suppliers-fui/suppliers-fui.component';
import { SuppliersLicenceComponent } from './suppliers-anre/suppliers-licence/suppliers-licence.component';
import { SuppliersDetailsComponent } from './suppliers-anre/suppliers-details/suppliers-details.component';
import {SharedModule} from '../../shared/shared.module';
import { OperatorsAnreComponent } from './operators-anre/operators-anre.component';
import { PosfFixComponent } from './posf-fix/posf-fix.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { AceEditorModule } from 'ng2-ace-editor';
import { MessagesComponent } from './messages/messages.component';
import { MessagesDetailsComponent } from './messages/messages-details/messages-details.component';

@NgModule({
  declarations: [
    PersonalDataAnreComponent,
    TaskAnreComponent,
    NotificationsAnreComponent,
    SuppliersAnreComponent,
    OperatorSupplierValidationComponent,
    SuppliersFuiComponent,
    SuppliersLicenceComponent,
    SuppliersDetailsComponent,
    OperatorsAnreComponent,
    PosfFixComponent,
    MessagesComponent,
    MessagesDetailsComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    Ng2SmartTableModule,
    ReactiveFormsModule,
    CKEditorModule,
    FormsModule,
    NgxJsonViewerModule, AceEditorModule,
    AnreRoutingModule,
    SharedModule
  ]
})
export class AnreModule { }
